import type { SVGProps } from "react";
import * as React from "react";

const SvgClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 6a1 1 0 1 0-2 0zm-1 6h-1a1 1 0 0 0 .553.894zm3.553 2.894a1 1 0 1 0 .894-1.788zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm-1 3v6h2V6zm.553 6.894 4 2 .894-1.788-4-2z"
    />
  </svg>
);
export default SvgClock;
